import { useMemo } from 'react';

import useWindowSize from 'apps/web_forms/hooks/useWindowSize';

/**
 * @returns {string} css padding value
 */
const getReactWrapperPadding = () => {
  const defaultValue = '35px';

  let calculated;
  try {
    const mainDiv = document.querySelectorAll('.main_div')[0];
    calculated = window.getComputedStyle(mainDiv).paddingLeft;
  } catch (e) {
    console.error('Issue detecting react wrapper padding'); // eslint-disable-line no-console
    console.error(e); // eslint-disable-line no-console
  }

  return calculated || defaultValue;
};

/**
 * The root div that is the container for react web forms has a padding on it,
 * which is determined dynamically via media queries in CSS in another repo we
 * can't access from here. Grab that value.
 * @returns {string} css padding value
 */
const useReactWrapperPadding = () => {
  const windowSize = useWindowSize();
  const reactWrapperPadding = useMemo(getReactWrapperPadding, [windowSize]);
  return reactWrapperPadding;
};

export { useReactWrapperPadding };
export default useReactWrapperPadding;
